import { AutogenModelWwwControl, AutogenRowWwwControl } from "./autogen/AutogenModelWwwControl";

export class ModelWwwControl extends AutogenModelWwwControl<RowWwwControl> {
	constructor() {
		super(RowWwwControl);
	}
}

export class RowWwwControl extends AutogenRowWwwControl {
}